module.exports = __webpack_public_path__ + "media/images/flags/cm-682aa0757e8bdc59936c09ed4a2bd1a6.svg";